module.exports = {
    defaultLocale: 'it',
    locales: ['it'],
    localePath: './locales',
    logger: (msg) => console.log(`[i18n error]`, msg),
    pages: {
        '*': ['common', 'resources', 'workspace'],

        '/confirm-email': ['confirmEmail'],
        '/forgot-password': ['forgotPassword'],
        '/login': ['login'],
        '/pricing': ['pricing'],
        '/reset-password': ['setPassword'],
        '/signup': ['signup'],
        '/sorting-quiz': ['quizResults'],
        '/verify-email': ['verifyEmail'],

        '/catalog': ['catalog', 'paths', 'path'],
        '/catalog/available': ['catalog', 'paths', 'path'],
        '/catalog/personal': ['catalog', 'paths', 'path'],
        '/catalog/categories/[slug]': ['catalog', 'paths', 'path'],

        '/paths/[slug]': ['paths', 'path'],
        '/courses/[slug]': ['course', 'path'],

        '/settings/account': ['settings'],
        '/settings/plan': ['settings', 'pricing'],

        '/supporters': ['supporters'],
    },
}
